
import React from 'react'
import "./Inputs.scss"

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

interface IPasswordInput extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  register: any;
  label: string;
}

function PasswordInput({ label, register, ...props }: IPasswordInput) {
    const [isShow, setIsShow] = React.useState<boolean>(false);
    return (
        <div className='PasswordInput'>
            <label htmlFor="1" className='PasswordInputLabel'>{label}</label>
            <div className='PasswordInput__wrapper'>
                <input id="1" type={!isShow ? "password" : "text"} className='PasswordInputContent' {...props} {...register} />
                <div className='PasswordInput__eye' onClick={() => setIsShow(prev => !prev)}>
                    {isShow ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </div>
            </div>
        </div>
    )
}

export default PasswordInput;